import eventMixin from '../lib/eventMixin';
import Logger from '../utilities/Logger';
import ThemeMediaPanel from './themeMediaPanel';

export default class ThemeBlockTwoPanelBanner {

	constructor(dom) {

		Logger.info('ThemeBlockTwoPanelBanner: initializing...');

		var self = this;

		this.dom = dom;

		// Gather all ThemeMediaPanel's
		const themeMediaPanels = this.dom.querySelectorAll('[data-theme-media-panel]');
		themeMediaPanels.forEach((dom) => {
			const panel = new ThemeMediaPanel(dom);
		});

	}

}

// Mixins
Object.assign(ThemeBlockTwoPanelBanner.prototype, eventMixin);
